'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ZoomableMapDisplay = require('./components/ZoomableMapDisplay');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ZoomableMapDisplay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/stackmap/lib/components/zoomable-map-display/index.js
// module id = 553
// module chunks = 1